module.exports = __webpack_public_path__ + "media/src/assets/Images/AppSectionMobileBackground-77e881671b1b8c1a75bdaba2151a068d.svg";